// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base', {
        url: '/base',
        parent: 'main',
        abstract: true,
        templateUrl: "main/base/base.tpl.html",
        controller: "BaseController as vm"
    });
}

// @ngInject
function BaseController() {
    var vm = this;
}

angular
    .module('main.base', ['base.dashboard', 'base.countries', 'base.articlecollections', 'base.articletypes', 'base.ordercollections', 'base.currencies', 'base.paymentterms', 'base.deliveryterms', 'base.deliveryplanningtemplates', 'base.shippingmethods', 'base.customergroups', 'base.ordertypes', 'base.invoicetypes', 'base.accounts', 'base.vats', 'base.paymenttypes', 'base.returnreasons'])
    .config(stateConfig)
    .controller('BaseController', BaseController);
